import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';

export const hideElement = css({
  display: 'none',
});
export const setLastSlideSpace = css({
  '.swiper-wrapper .swiper-slide:first-child': {
    marginRight: '0px !important',
    [MediaQueries.md]: {
      marginRight: '0px !important',
    },
    [MediaQueries.sm]: {
      marginRight: '0px !important',
    },
  },
  '.swiper-wrapper .swiper-slide:nth-child(2)': {
    marginRight: '0px !important',
    [MediaQueries.md]: {
      marginRight: '0px !important',
    },
    [MediaQueries.sm]: {
      marginRight: '0px !important',
    },
  },
  '.swiper-wrapper .swiper-slide:nth-child(3)': {
    marginRight: '15px !important',
    [MediaQueries.lg]: {
      marginRight: '0px !important',
    },
    [MediaQueries.md]: {
      marginRight: '0px !important',
    },
    [MediaQueries.sm]: {
      marginRight: '12px !important',
    },
  },
});
export const homepageSlide = css({
  '.swiper-pagination-custom': {
    left: '-10px',
    bottom: '0px',
    [MediaQueries.sm]: {
      left: '-13px',
    },
  },
  [MediaQueries.xl]: {
    width: 'calc(100% + 60px)',
  },
  [MediaQueries.md]: {
    width: 'calc(100% + 50px)',
  },

  [MediaQueries.lg]: {
    width: 'calc(100% + 40px)',
  },

  [MediaQueries.sm]: {
    width: 'calc(100% + 25px)',
  },

  width: 'calc(100% + 60px)',
  position: 'relative',

  '.shadowslide': {
    height: '320px',
    display: 'none',
    zIndex: '9',
    right: '0',
    width: '270px',
    position: 'absolute',
    background:
      'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
    [MediaQueries.sm]: {
      minHeight: '320px',
      width: '100px',
    },
  },

  // '.swiper-pagination': {
  //   display: 'none',
  //   [MediaQueries.sm]: {
  //     display: 'flex',
  //     justifyContent: 'center',
  //   },
  // },

  '.swiper-container': {
    paddingBottom: '48px',

    [MediaQueries.sm]: {},

    [MediaQueries.lg]: {},

    [MediaQueries.md]: {},

    // '.swiper-wrapper': {
    //   display: 'flex',
    //   boxSizing: 'unset',
    //   [MediaQueries.sm]: {
    //     paddingBottom: '40px',
    //   },

    '.swiper-slide': {
      // [MediaQueries.xl]: {
      //   width: '304px !important',
      // },
      // [MediaQueries.lg]: {
      //   width: '296px !important',
      //   marginRight: '25px !important',
      // },
      // [MediaQueries.md]: {
      //   width: '320px !important',
      // },
      // [MediaQueries.sm]: {
      //   width: '304px !important',
      // },
    },
    // },
  },

  '.regus-button-prev': {
    display: 'none',
  },
  '.regus-button-next': {
    display: 'none',
  },

  '&:hover': {
    '.regus-button-prev': {
      display: 'flex',
      justifyContent: 'center',
      [MediaQueries.sm]: {
        display: 'none',
      },
    },
    '.regus-button-next': {
      display: 'flex',
      alignItems: 'center',
      [MediaQueries.sm]: {
        display: 'none',
      },
    },

    '.swiper-pagination-custom': {
      display: 'block',
    },
  },

  '.swiper-pagination-bullet-active': { opacity: 1, background: '#008385' },
  '.swiper-pagination-bullet': { margin: '0px 4px' },

  '.hiddenseperator': {
    display: 'none',
    width: '155px',
    height: '400px',
    position: 'absolute',
    left: '-25px',
    background: '#fff',
    zIndex: '1',
    top: '0px',
    [MediaQueries.xl]: {
      width: '165px',
    },
    [MediaQueries.sm]: {
      display: 'none',
    },
  },

  '.regus-button-prev': {
    position: 'absolute',
    bottom: '50%',
    alignItems: 'center',
    zIndex: 1,
    cursor: 'pointer',
    display: 'none',
    border: '0',
    outline: '0px',
    width: '48px',
    alignItems: 'center',
    justifyContent: 'center',
    height: '48px',
    borderRadius: '50%',
    boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
    padding: '18px',
    left: '-25px',
    [MediaQueries.sm]: {
      display: 'none',
    },
    [MediaQueries.md]: {
      left: '-19px',
    },
  },

  '.regus-button-next': {
    position: 'absolute',
    bottom: '50%',
    cursor: 'pointer',
    display: 'none',
    zIndex: 1,
    width: '48px',
    boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.12)',
    height: '48px',
    borderRadius: '50%',
    outline: '0px',
    border: '0',
    backgroundColor: '#fff',
    padding: '18px',
    padding: '18px',
    right: '44px',
    [MediaQueries.xl]: {
      right: '44px',
    },
    [MediaQueries.sm]: {
      display: 'none',
    },
    [MediaQueries.md]: {
      right: '50px',
    },
    [MediaQueries.lg]: {
      right: '35px',
    },
  },
});
